export default __webpack_public_path__ + "static/media/DAIF_Data_In.32c2101c.mp4";